import React, { Fragment } from "react";
export var OpacityOverlay = function (_a) {
    var children = _a.children, on = _a.on;
    return (React.createElement(Fragment, null, on ? (React.createElement(Fragment, null,
        React.createElement("div", { className: "opacity-overlay" }),
        React.createElement("div", { className: "opacity-overlay--content" }, children))) : (children)));
};
